
import { Component, Vue } from "vue-property-decorator";

@Component
export default class SnackbarMixin extends Vue {
  snackbarText = "";

  get displaySnackbar() {
    return Boolean(this.snackbarText);
  }

  async showSnackbar(message: string) {
    this.snackbarText = "";
    await this.$nextTick();
    this.snackbarText = message;
  }
}
